import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const publicUrl = (path) => `${process.env.REACT_APP_PUBLIC_URL}${path}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Ocurrió un error. Intenta nuevamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
